import angular from 'angular';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import env from '../../config/environment';

import { lazyLoad, isMobile } from '../../utils/helpers';

const optionalModules = []

if (env.sentry) {
  Sentry.init({
    ...env.sentry,
    integrations: [new Integrations.Angular()],
  })

  optionalModules.push('ngSentry')
}

window.appAngular = angular.module('eficienciaFiscalModule', [
  'ajoslin.promise-tracker',
  'angular-inview',
  'angular.paging',
  'angularFileUpload',
  'checklist-model',
  'gridshore.c3js.chart',
  'ngAnimate',
  'ngCookies',
  'ngFileSaver',
  'ngFileUpload',
  'ngMessages',
  'ui.router',
  'ngSanitize',
  'ngTable',
  'ui.ace',
  'ui.bootstrap',
  'ui.bootstrap.collapse',
  'ui.jq',
  'ui.mask',
  'ui.select',
  'ui.utils.masks',
  'xeditable',
  ...optionalModules
])

window.appAngular.config([
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider',
  '$compileProvider',
  '$controllerProvider',
  '$filterProvider',
  '$provide',
  (
    $stateProvider,
    $urlRouterProvider,
    $locationProvider,
    $compileProvider,
    $controllerProvider,
    $filterProvider,
    $provide,
  ) => {
    window.appAngular.register = {
      component: $compileProvider.component,
      controller: $controllerProvider.register,
      directive: $compileProvider.directive,
      filter: $filterProvider.register,
      factory: $provide.factory,
      service: $provide.service
    };

    $locationProvider.html5Mode(true);

    const viewPath = '/app/module/eficiencia-fiscal/view/'

    $stateProvider.state({
      name: 'login',
      url: '/login',
      component: 'efLogin'
    })

    $stateProvider.state({
      name: 'logout',
      url: '/logout',
      controller: ['UsuariosService', '$state', (UsuariosService, $state) => {
        if (UsuariosService.usuarioLogado) {
          UsuariosService.logout().then(() => $state.go('login'))
        } else {
          $state.go('login')
        }
      }]
    })

    $stateProvider.state({
      name: 'oauthLogin',
      url: '/oauth-login?token',
      component: 'efOauthLogin'
    })

    $stateProvider.state({
      name: 'forgottenPassword',
      url: '/esqueci-a-senha?token',
      component: 'efForgottenPassword'
    })

    $stateProvider.state({
      name: 'cadastroConfirmacao',
      url: '/cadastro-confirmacao?token',
      component: 'efCadastroConfirmacao'
    })

    $stateProvider.state({
      name: 'layout',
      component: 'efLayout'
    })

    $stateProvider.state({
      name: 'layout.configuracoes',
      url: '/configuracoes',
      controller: 'configuracaoTabsController as ctrl',
      templateUrl: viewPath + 'configuracao/index.html'
    })

    $stateProvider.state({
      name: 'layout.dashboard',
      url: '/dashboard',
      component: 'painelFerramentas'
    })

    $stateProvider.state({
      name: 'layout.contratos',
      url: '/contratos/:contratoId',
      template: `<div class="well well-sm well-light no-padding"><contratos/></div>`,
    })

    $stateProvider.state({
      name: 'layout.contratosDetalhamento',
      url: '^/contratos/:contratoId/detalhamento',
      template: `<div class="well well-sm well-light no-padding"><contrato-detalhamento/></div>`
    })

    $stateProvider.state({
      name: 'auditoriaContinuaShare',
      url: '/auditoria-continua/share/:token',
      templateUrl: viewPath + 'dashboard/auditoria-estoque/share/index.html',
      controller: 'auditoriaContinuaShareController as ctrl'
    })

    $stateProvider.state({
      name: 'layout.arquivosDigitaisIndex',
      url: '/arquivos-digitais',
      template: `<div class="well well-sm well-light no-padding"><arquivos-digitais/></div>`
    })

    $stateProvider.state({
      name: 'layout.businessIntelligence',
      url: '/business-intelligence',
      template: `<vue-lazy-load/>`,
      resolve: lazyLoad(["vue/business-intelligence"])
    })

    $stateProvider.state({
      name: 'layout.arquivosDigitais',
      url: '/arquivos-digitais',
      component: 'arquivosDigitais'
    })

    $stateProvider.state({
      name: 'layout.arquivosDigitaisNFeRecebidas',
      url: '/arquivos-digitais/nfe-recebidas',
      component: 'arquivosDigitais'
    })

    $urlRouterProvider.otherwise('/login')
  }
])

window.appAngular.value('moduleApiName', 'eficiencia-fiscal')

window.appAngular.run([
  '$transitions',
  '$state',
  'editableOptions',
  '$window',
  '$templateCache',
  '$http',
  'UsuariosService',
  '$rootScope',
  function ($transitions, $state, editableOptions, $window, $templateCache, $http, UsuariosService, $rootScope) {
    editableOptions.theme = 'bs3';
    $http.defaults.withCredentials = true

    if ($window._gaq)
      $transitions.onEnter({ to: '**' }, () => {
        $window._gaq.push(['_trackPageview', window.location.pathname + window.location.hash]);
      });

    $templateCache.put('erros-validacao', "" +
      "<span ng-message='required' class='help-block txt-color-red font-xs no-margin'>Este campo é obrigatório.</span>" +
      "<span ng-message='timeRange' class='help-block txt-color-red font-xs no-margin'>O período informado é inválido.</span>"
    );

    $transitions.onBefore({ to: 'layout.**' }, transition => {
      //Verifica qual será a próxima url antes de cada alteração de urls,
      //para saber se deve esconder ou não o select da seleção das empresas
      $rootScope.currentURL = transition.to().url

      //Ao trocar de url fecha o menu quando for mobile
      const isMenuOpen = document.querySelector('.navbar-collapse.in') != null
      if (isMobile() && isMenuOpen) {
        document.querySelector('.navbar-toggle').click()
      }

      if (UsuariosService.usuarioLogado) return true

      $state.go('login')

      return false
    })
  }
]);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js');
  });
}
